const TRUE = '1';
const FALSE = '0';

export function setIsEvyveska(value: boolean) {
  localStorage.setItem('IS_EVYVESKA', value? TRUE: FALSE);
}

export function isEvyveska() {

  if(localStorage.getItem('IS_EVYVESKA') === TRUE) {
    return true;
  }

  return false;
}